import TextExtractor from "./text_extractor";
import LinkExtractor from "./link_extractor";
import InputExtractor from "./input_extractor";
import { Extractor } from "./../types";

export const ExtractorMap: Record<string, Extractor> = {
  text: new TextExtractor(),
  link: new LinkExtractor(),
  input: new InputExtractor(),
};
